import {zip} from 'lodash'
import styles from './loading.module.scss'

interface ISpinner {
	position?: 'fixed' | 'absolute'
	backgroundColor?: string
	zIndex?: number
}

/**
 * 로딩 스피너
 */
const LoadingSpinner = ({
	position = 'fixed',
	backgroundColor = 'rgba(255, 255, 255, 0.9)',
	zIndex = 200,
}: ISpinner) => {
	return (
		<>
			<div
				className={styles['loading-spinner']}
				style={{
					position: `${position}`,
					backgroundColor: `${backgroundColor}`,
					zIndex: `${zIndex}`,
				}}
			>
				<div className={styles['spinner']}>
					<span></span>
				</div>
			</div>
		</>
	)
}

export default LoadingSpinner
